export default __webpack_public_path__ + "static/media/nationalities.08783c64.svg";